import {
  OverlayArrow as ReactAriaOverlayArrow,
  Tooltip as ReactAriaTooltip,
  TooltipProps as ReactAriaTooltipProps,
  TooltipTrigger as ReactAriaTooltipTrigger,
  TooltipTriggerComponentProps as ReactAriaTooltipTriggerProps,
} from 'react-aria-components/Tooltip';

import css from './Tooltip.css';

/** Wraps a custom trigger element, e.g. a plain `<button>`, so a `TooltipTrigger` can attach to it */
export { Focusable } from 'react-aria-components/Focusable';

/**
 * `triggerRef` is only needed for a trigger that can't take the ref a `TooltipTrigger` passes to it;
 * the tooltip then positions itself against the given element instead.
 */
export interface TooltipProps extends Pick<ReactAriaTooltipProps, 'offset' | 'placement' | 'triggerRef'> {
  children: React.ReactNode;
}

export const Tooltip = ({ children, offset = 0, placement = 'bottom', ...props }: TooltipProps) => {
  return (
    <ReactAriaTooltip className={css.root} offset={offset} placement={placement} {...props}>
      <ReactAriaOverlayArrow className={css.overlayArrow}>
        <svg width={16} height={6} viewBox="0 0 16 6">
          <path d="M0 6 L8 0 L16 6 Z" />
        </svg>
      </ReactAriaOverlayArrow>
      {children}
    </ReactAriaTooltip>
  );
};

/**
 * `isOpen` makes the trigger controlled, for a trigger element that can't take the event props
 * a `TooltipTrigger` passes to it and opens the tooltip itself.
 */
interface TooltipTriggerProps extends Pick<ReactAriaTooltipTriggerProps, 'isOpen'> {
  children: React.ReactNode;
}

export const TooltipTrigger = (props: TooltipTriggerProps) => {
  return <ReactAriaTooltipTrigger delay={400} closeDelay={0} {...props} />;
};
